import { render, staticRenderFns } from "./AnchorEditor.vue?vue&type=template&id=a2cc473e&"
import script from "./AnchorEditor.vue?vue&type=script&lang=js&"
export * from "./AnchorEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports